import { render, staticRenderFns } from "./password-required.vue?vue&type=template&id=3af91298&scoped=true"
import script from "./password-required.vue?vue&type=script&lang=js"
export * from "./password-required.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af91298",
  null
  
)

export default component.exports